
/**
 * Load dependencies
 */

import Vue from 'vue';
import Vuex from 'vuex';

// Import setup module to configure
import setup from './setup';

// Import bootstrap-vue components
import bootstrap from './bootstrap-setup.js';

// Import responsive module
import responsive from './store/modules/responsive/index';

/**
 * Register global vue components so they may be used in blade templates
 * Example: @component/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component('offer-details-card', 		() => import('@component/OfferDetailsCard.vue'));
Vue.component('related-offers', 			() => import('@component/RelatedOffers.vue'));
Vue.component('downsell-option', 			() => import('@component/DownsellOption.vue'));
Vue.component('upsell-option', 				() => import('@component/UpsellOption.vue'));
Vue.component('upsell-multiple', 			() => import('@component/UpsellMultiple.vue'));
Vue.component('featured-offers', 			() => import('@component/FeaturedOffers.vue'));
Vue.component('offer-options', 				() => import('@component/OfferOptions.vue'));
Vue.component('receipt', 					() => import('@component/Receipt.vue'));
Vue.component('shipping-modal', 			() => import('@component/ShippingAddressModal.vue'));
Vue.component('add-to-cart', 				() => import('@component/AddToCart.vue'));
Vue.component('upsell-decline', 			() => import('@component/UpsellDecline.vue'));

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		responsive
	},
});

/**
 * Create a Vue application instance
 */

import sharedSetup from '@js/vue-setup.js';
Vue.use(sharedSetup);

new Vue({
	el: (typeof altAppSelector === 'undefined' || !altAppSelector) ? '#app' : altAppSelector,
	store
});
